module.exports = __webpack_public_path__ + "static/media/tiles_close_icon.0d996dd6.png";